import { createContext } from 'react';

export interface TranslationsContextValue {
  translations?: Record<string, string>;
  onSubmit?: (...args: unknown[]) => unknown;
}

export const TranslationsContext = createContext<TranslationsContextValue>({
  translations: {},
  onSubmit: undefined
});
